import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../contexts/stylesheet.js";
import { useA11yId } from "../../hooks/useA11yId.js";
const LinkToggle = ({ onToggle, children, showMore, hideMore, groupLabel, bullets, forceRender, ...rest })=>{
    const { Link } = useStylesheet().extend(...extendCommonStylesheet);
    const [isOpen, setIsOpen] = useState(false);
    const a11yExpanded = useA11yId();
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            bullets && /*#__PURE__*/ _jsx("span", {
                "aria-hidden": true,
                children: "\xa0\xa0•\xa0\xa0"
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: "#",
                onClick: (e)=>{
                    const newOpen = !isOpen;
                    setIsOpen(newOpen);
                    onToggle?.(newOpen);
                    e.preventDefault();
                },
                onKeyDown: (e)=>{
                    if (e.code.toLowerCase() === "space") {
                        e.target.click();
                    }
                },
                ...groupLabel ? {
                    "aria-label": `${isOpen ? hideMore : showMore}: ${groupLabel}`
                } : {},
                ...children ? {
                    "aria-expanded": isOpen,
                    "aria-controls": a11yExpanded,
                    role: "button"
                } : {},
                ...rest,
                children: isOpen ? hideMore : showMore
            }),
            children && /*#__PURE__*/ _jsx("div", {
                hidden: !isOpen,
                id: a11yExpanded,
                children: (isOpen || forceRender) && children
            })
        ]
    });
};
export { LinkToggle };
